import { PencilSquareIcon, XMarkIcon } from '@heroicons/react/24/outline'

type Props = {
  isOpen: boolean
  appId: string | null
  noteDraft: string
  onNoteDraftChange: (value: string) => void
  onClose: () => void
  onSave: (appId: string, note: string) => void
}

export const NoteModal = ({
  isOpen,
  appId,
  noteDraft,
  onNoteDraftChange,
  onClose,
  onSave,
}: Props) => {
  if (!isOpen || !appId) return null

  const handleSave = () => {
    onSave(appId, noteDraft)
    onClose()
  }

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/60 px-4">
      <div className="w-full max-w-lg border border-app-line bg-app-surface p-4 space-y-3 rounded-2xl shadow-app-card">
        <div className="flex items-center justify-between">
          <p className="text-sm font-semibold text-app-ink flex items-center gap-2">
            <PencilSquareIcon className="h-4 w-4" aria-hidden="true" /> Note
          </p>
          <button
            onClick={onClose}
            className="text-app-muted hover:text-app-ink"
          >
            <XMarkIcon className="h-5 w-5" />
          </button>
        </div>
        <textarea
          rows={4}
          value={noteDraft}
          onChange={(e) => onNoteDraftChange(e.target.value)}
          className="w-full rounded-lg border border-app-line bg-app-surface px-3 py-2 text-sm text-app-ink focus:border-app-accent focus:outline-none"
          placeholder="Add a note (context, follow-ups, recruiter calls, questions...)"
          autoFocus
        />
        <div className="flex justify-end gap-2">
          <button
            onClick={onClose}
            className="rounded-lg border border-app-line px-3 py-2 text-sm font-semibold text-app-ink hover:bg-app-subtle"
          >
            Cancel
          </button>
          <button
            onClick={handleSave}
            className="rounded-lg bg-app-primary px-3 py-2 text-sm font-semibold text-white hover:bg-app-primary-hover"
          >
            Save
          </button>
        </div>
      </div>
    </div>
  )
}

